import React, { Component } from "react";
import { TextField } from "reactackle";
import { isMobile } from "react-device-detect";
import AgraniRegCard from "./AgraniRegCard";

class AgraniService extends Component {
  state = {
    data: {
      path: "remitService",
      payload: {}
    },
    searchFilters: {
      category: "REMITTANCE"
    }
  };

  //single method that work for all fields
  //takes incoming id of the field and then adds field data to state
  stateChangeHandler = (val, id, isPayload) => {
    // console.log(
    //   "val: " + JSON.stringify(val) + " id: " + id + " isPayload: " + isPayload
    // );
    let tmpState = {};
    tmpState[id] = val;

    if (isPayload) {
      this.setState(prevState => {
        if (prevState && prevState.data.payload !== null) {
          return {
            ...prevState,
            data: {
              ...prevState.data,
              payload: {
                ...prevState.data.payload,
                ...tmpState
              }
            }
          };
        } else {
          return {
            ...prevState,
            data: {
              path: prevState.data.path,
              payload: {
                ...tmpState
              }
            }
          };
        }
      });
    } else {
      this.setState(prevState => {
        return {
          ...prevState,
          ...tmpState
        };
      });
    }
  };

  categIsSelected = categName => {
    //console.log(categName + " " + this.state.searchFilters.category);
    let isSelected = false;

    if (this.state.searchFilters.category === categName) {
      isSelected = true;
    }

    return isSelected;
  };

  getCategTabs = () => {
    //console.log(JSON.stringify(this.props.createTable));

    let categList = [
      { name: "REMITTANCE", icon: "fa fa-flash", color: "blue" },
      { name: "REGISTRATION", icon: "fa fa-book", color: "black" }
    ];

    if (categList && categList.length > 0) {
      //console.log("got categ list: " + JSON.stringify(categList));
      return categList.map(item => {
        return (
          <div
            style={{
              height: this.categIsSelected(item.name) ? "37px" : "35px",
              margin: "1px",
              backgroundColor: "white",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minWidth: "40%",
              fontSize: "11px",
              textAlign: "center",
              border: this.categIsSelected(item.name)
                ? "1px solid gainsboro"
                : null,
              borderBottom: this.categIsSelected(item.name)
                ? "2px solid grey"
                : "1px solid gainsboro",
              borderTopLeftRadius: "5px",
              borderTopRightRadius: "5px"
            }}
            onClick={() => {
              if (item.name === "ALL") {
                this.stateChangeHandler({}, "searchFilters", false);
              } else {
                this.stateChangeHandler(
                  { category: item.name },
                  "searchFilters",
                  false
                );
              }

              this.props.setScroll(true);
            }}
          >
            <div>
              <div>
                {item.name}
                <span style={{ marginLeft: "3px" }}>
                  <i style={{ color: item.color }} className={item.icon} />
                </span>
              </div>
              <div>{item.banglaText}</div>
            </div>
          </div>
        );
      });
    }
  };

  getRegCards = () => {
    if (this.props.myRemitRegs && this.props.myRemitRegs.length > 0) {
      let filtRecs = [];
      if (this.state.searchVal && this.state.searchVal !== "") {
        let searchVal = this.state.searchVal.toLowerCase();
        filtRecs = this.props.myRemitRegs.filter(reg => {
          let found = false;
          Object.keys(reg).map(key => {
            if (
              reg[key] &&
              reg[key] !== "" &&
              reg[key].toLowerCase().includes(searchVal)
            ) {
              found = true;
            }
          });
          return found;
        });
      } else {
        filtRecs = this.props.myRemitRegs;
      }

      return filtRecs.map(req => {
        return (
          <AgraniRegCard
            req={req}
            firebase={this.props.firebase}
            selectedExchange={this.props.selectedExchange}
          />
        );
      });
    } else {
    }
  };

  agraniApps = () => {
    return <div></div>;
  };

  agraniRegistration = () => {
    return <div>{this.getRegCards()}</div>;
  };

  render() {
    return (
      <div
        style={{
          padding: "0px"
        }}
      >
        <div
          style={{
            marginLeft: "5px",
            marginRight: "5px",
            marginTop: "-15px",
            marginBottom: "15px"
          }}
        >
          <div>
            <div
              style={{
                padding: "1px",
                textAlign: "right",
                border: "1px solid gainsboro",
                borderRadius: isMobile ? "5px" : "0px",
                backgroundColor: "white",
                zIndex: "-9"
              }}
            >
              <TextField
                value={this.state["searchVal"]}
                onChange={e => {
                  this.stateChangeHandler(e.value, "searchVal", false);
                }}
                fullWidth
                placeholder="Search..."
              />
            </div>
          </div>
        </div>
        <div
          style={{
            marginLeft: "3px",
            marginRight: "3px"
          }}
        >
          <div
            style={{
              margin: "0px",
              zIndex: "5",
              width: "100%",
              display: "flex",
              alignItems: "flex-end",
              padding: "2px",
              flexDirection: "row",
              maxWidth: "600px"
            }}
          >
            {this.getCategTabs()}
          </div>
          {this.state.searchFilters.category === "REMITTANCE" && (
            <div
              style={{
                backgroundColor: "white",
                padding: "5px",
                marginLeft: "3px",
                marginRight: "3px"
              }}
            >
              {this.agraniApps()}
            </div>
          )}
          {this.state.searchFilters.category === "REGISTRATION" && (
            <div
              style={{
                backgroundColor: "white",
                padding: "5px",
                marginLeft: "3px",
                marginRight: "3px"
              }}
            >
              {this.agraniRegistration()}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default AgraniService;



// WEBPACK FOOTER //
// ./src/app/components/Screens/landingPage/AgraniService.jsx